
const ConsultationHero = () => {
  return (
    <section 
      className="relative py-24 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/476b4dcaa0f3e5c1cdbe0463e845b920.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-5xl font-bold text-white mb-6">
          Request Professional Consultation
        </h1>
        <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
          Connect with Golden Black's expert technical team for customized chemical solutions. 
          Our experienced engineers will analyze your requirements and provide tailored recommendations.
        </p>
        <div className="bg-teal-600/20 backdrop-blur-sm rounded-lg p-6 max-w-2xl mx-auto">
          <p className="text-white text-lg font-semibold">
            ✓ Expert Technical Analysis
          </p>
          <p className="text-white text-lg font-semibold">
            ✓ Customized Solutions
          </p>
          <p className="text-white text-lg font-semibold">
            ✓ Rapid Response Team
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConsultationHero;
